import { createAsyncThunk, createSelector, createSlice, PayloadAction, SerializedError } from '@reduxjs/toolkit';
import { ApiState } from 'models';
import { getSelfScheduleAppointmentTypes, ScheduleAppointmentTypesResponse } from 'services';

export type State = ApiState<ScheduleAppointmentTypesResponse, SerializedError>;

// https://redux-toolkit.js.org/api/createAsyncThunk
export const fetchSelfScheduleAppointmentTypes = createAsyncThunk(
  'get/selfScheduleAppointmentTypes',
  async () => await getSelfScheduleAppointmentTypes()
);

export const initialState = {
  isLoading: true,
  hasLoaded: false,
  data: [],
  error: null,
} as State;

//https://redux-toolkit.js.org/api/createSlice
const selfScheduleAppointmentTypesSlice = createSlice({
  name: 'selfScheduleAppointmentTypes',
  initialState,
  //immer is behind the scenes to keep state immutable only the props you changes will be changed
  reducers: {
    unmountSelfScheduleAppointmentTypes: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSelfScheduleAppointmentTypes.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(
      fetchSelfScheduleAppointmentTypes.fulfilled,
      (state, action: PayloadAction<ScheduleAppointmentTypesResponse>) => {
        state.isLoading = false;
        state.data = action.payload;
        state.hasLoaded = true;
      }
    );

    builder.addCase(fetchSelfScheduleAppointmentTypes.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const stateSelector_ = (state: { selfScheduleAppointmentTypes: State }): State =>
  state.selfScheduleAppointmentTypes;

export const selfScheduleAppointmentTypes_ = createSelector(stateSelector_, (state) => state.data);

export const selfScheduleAppointmentTypesIsLoading_ = createSelector(stateSelector_, (state) => state.isLoading);

export const selfScheduleAppointmentTypesHasLoaded_ = createSelector(stateSelector_, (state) => state.hasLoaded);

export const { unmountSelfScheduleAppointmentTypes } = selfScheduleAppointmentTypesSlice.actions;

export default selfScheduleAppointmentTypesSlice.reducer;
